import React from 'react';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { IVendorData } from '../../../types';
import { ReactComponent as GustoIcon } from '../../../assets/svg/vendors/gusto-icon.svg';

interface IProps {
  headerText?: string;
  data: IVendorData;
  showLogo?: boolean;
}

const GustoConnectionInstructions = ({ headerText, data, showLogo }: IProps) => (
  <div
    data-testid='GustoApp__card-instructions'
    className='w-[552px] h-[568px] bg-bw00 rounded-[8px] px-[40px] pt-[33px] pb-[29px] flex flex-col justify-between shadow-widgetCard'
  >
    <div>
      <div className={`${showLogo ? 'flex items-center' : ''}`}>
        {showLogo && (
          <div className='mr-[10px] flex items-center justify-center w-[36px] h-[36px]'>
            <GustoIcon className='rounded-[6px]' />
          </div>
        )}
        {headerText && (
          <div
            data-testid='GustoApp__card-instructions-header'
            className='font-metricRMedium text-sm text-bw05 tracking-wide'
          >
            {headerText}
          </div>
        )}
        <Heading.H7 fontWeight={FontWeight.MEDIUM} data-testid='GustoApp__card-instructions-title'>
          {data.displayOptions[0].title}
        </Heading.H7>
      </div>
      <Text.H9 data-testid='GustoApp__card-instructions-description' className='mt-[16px] mb-[24px]'>
        {data.displayOptions[0].vendorDescription}
      </Text.H9>
      <Text.H9 data-testid='GustoApp__card-instructions-list-title' className='mb-[8px]'>
        {data.displayOptions[0].subtitle}
      </Text.H9>
      <ul className='flex flex-col gap-[12px]'>
        {data.displayOptions[0].steps.map((step: string, index: number) => (
          <li data-testid='GustoApp__instruction-item' key={step} className='flex flex-row'>
            <Heading.H10 className='mr-[5px] text-text-brand-primary'>{`${index + 1}. `}</Heading.H10>
            <Heading.H10>{`${step}`}</Heading.H10>
          </li>
        ))}
      </ul>
    </div>
    <div>
      <Heading.H10 className='text-text-main-secondary'>{data.displayOptions[0].disclaimer}</Heading.H10>
    </div>
  </div>
);

export default GustoConnectionInstructions;
